import api from "!../../../../../../../../../fixmycar/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../../../../fixmycar/node_modules/css-loader/dist/cjs.js??clonedRuleSet-12.use[1]!../../../../../../../../../fixmycar/node_modules/vue-loader/dist/stylePostLoader.js!../../../../../../../../../fixmycar/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-12.use[2]!../../../../../../../../../fixmycar/node_modules/sass-loader/dist/cjs.js??clonedRuleSet-12.use[3]!../../../../../../../../../fixmycar/node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Basket.vue?vue&type=style&index=0&id=7fa4abb2&lang=scss&scoped=true";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};